import { Routes, RouterModule } from '@angular/router';
import { AbpManagementComponent } from './abp-management.component';

const routes: Routes = [
  {
    path: '',
    component: AbpManagementComponent,
  },
];

export const AbpManagementRoutingModule = RouterModule.forChild(routes);
